
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FSharpSet__Add, FSharpSet__Remove, empty, FSharpSet__Contains, ofList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { length, singleton, ofArray, append, filter, sortBy, head, tail, isEmpty, map } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { LabelId__get_unwrap } from "../../../Shared/Shared.js";
import { createObj, equals, comparePrimitives } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_1, singleton as singleton_1, collect, append as append_1, delay, unfold, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { concat, join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { rangeDouble } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { Badge } from "../../../Components/Badge.js";
import { Hierarchy_getDisplayName } from "../../../Shared/Category.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { Button } from "../../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { withoutOnboardingTourQueryParams, isCategoryLabelsTourOverviewPhase } from "../../../Common.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../../Components/TourGuide.js";

export function CategoryTreeView(props) {
    let elems_13, elems_8, elems_12, elems_10, elems_9, elems_11;
    const t = useTranslation()[0];
    const allIds = ofList(map((c) => LabelId__get_unwrap(c.Id), props.Categories), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const patternInput_1 = reactApi.useState(allIds);
    const setExpandedIds = patternInput_1[1];
    const expandedIds = patternInput_1[0];
    const flatRows = toList(unfold((stack) => {
        if (!isEmpty(stack)) {
            const rest = tail(stack);
            const depth = head(stack)[1] | 0;
            const category = head(stack)[0];
            const children = sortBy((c_3) => c_3.Name.toLocaleLowerCase(), filter((c_2) => equals(c_2.ParentLabelId, category.Id), props.Categories), {
                Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
            });
            return [[category, depth, children], (!isEmpty(children) && FSharpSet__Contains(expandedIds, LabelId__get_unwrap(category.Id))) ? append(map((c_6) => [c_6, depth + 1], children), rest) : rest];
        }
        else {
            return undefined;
        }
    }, map((r) => [r, 0], sortBy((c_5) => c_5.Name.toLocaleLowerCase(), filter((c_4) => (c_4.ParentLabelId == null), props.Categories), {
        Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
    }))));
    return reactElement("div", createObj(singleton((elems_13 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "mb-3"])], (elems_8 = [reactElement("button", {
        className: join(" ", ["text-sm", "font-semibold", "flex", "items-center", "gap-1.5", "px-3", "py-1.5", "hover:bg-background", "rounded-lg", "transition-colors", "text-text-muted"]),
        onClick: (_arg_2) => {
            setExpandedIds(ofList(map((c_1) => LabelId__get_unwrap(c_1.Id), props.Categories), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            }));
        },
        children: t("category.expand_all"),
    }), reactElement("button", {
        className: join(" ", ["text-sm", "font-semibold", "flex", "items-center", "gap-1.5", "px-3", "py-1.5", "hover:bg-background", "rounded-lg", "transition-colors", "text-text-muted"]),
        onClick: (_arg_3) => {
            setExpandedIds(empty({
                Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
            }));
        },
        children: t("category.collapse_all"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), reactElement("table", createObj(ofArray([["className", join(" ", ["w-full", "border-collapse", "text-left", "bg-white"])], (elems_12 = [reactElement("thead", createObj(singleton((elems_10 = [reactElement("tr", createObj(ofArray([["className", join(" ", ["bg-white"])], (elems_9 = [reactElement("th", {
        className: join(" ", ["py-2.5", "px-4", "text-sm", "font-semibold", "text-left", "border-b", "border-border"]),
        children: t("general.category"),
    }), reactElement("th", {
        className: join(" ", ["py-2.5", "px-4", "text-sm", "font-semibold", "text-left", "border-b", "border-border"]),
        children: t("category.preview"),
    }), reactElement("th", {
        className: join(" ", ["py-2.5", "px-4", "text-sm", "font-semibold", "text-center", "border-b", "border-border"]),
        children: t("category.visible_for_user"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])))), reactElement("tbody", createObj(singleton((elems_11 = map((tupledArg) => {
        let elems_7, elems_2, elems_1, elems_4, elems_3, elems_6, elems_5;
        const category_1 = tupledArg[0];
        const children_1 = tupledArg[2];
        const hasChildren = !isEmpty(children_1);
        const isExpanded = FSharpSet__Contains(expandedIds, LabelId__get_unwrap(category_1.Id));
        return reactElement("tr", createObj(ofArray([["key", LabelId__get_unwrap(category_1.Id)], ["className", join(" ", ["group", "hover:bg-[#F2F4FD]", "transition-colors", "cursor-pointer"])], ["onClick", (_arg) => {
            RouterModule_nav(ofArray(["settings", "categories", LabelId__get_unwrap(category_1.Id)]), 1, 1);
        }], (elems_7 = [reactElement("td", createObj(ofArray([["className", join(" ", ["py-2.5", "px-4", "border-b", "border-border"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-1"])], (elems_1 = toList(delay(() => append_1(collect((matchValue) => singleton_1(reactElement("div", {
            className: join(" ", ["w-7", "flex-shrink-0"]),
        })), rangeDouble(0, 1, tupledArg[1] - 1)), delay(() => {
            let elems;
            return append_1(hasChildren ? singleton_1(reactElement("button", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "w-6", "h-6", "rounded", "hover:bg-background", "transition-colors", "text-text-muted", "flex-shrink-0"])], ["onClick", (e) => {
                e.stopPropagation();
                const id = LabelId__get_unwrap(category_1.Id);
                if (FSharpSet__Contains(expandedIds, id)) {
                    setExpandedIds(FSharpSet__Remove(expandedIds, id));
                }
                else {
                    setExpandedIds(FSharpSet__Add(expandedIds, id));
                }
            }], (elems = [reactElement("span", {
                className: join(" ", toList(delay(() => append_1(singleton_1("text-[10px]"), delay(() => append_1(singleton_1("inline-block"), delay(() => append_1(singleton_1("transition-transform"), delay(() => append_1(singleton_1("duration-200"), delay(() => (isExpanded ? singleton_1("rotate-90") : singleton_1(""))))))))))))),
                children: "▶",
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton_1(reactElement("span", {
                className: join(" ", ["w-6", "flex-shrink-0"]),
            })), delay(() => append_1(singleton_1(reactElement("div", {
                className: join(" ", ["w-3", "h-3", "rounded-full", "flex-shrink-0"]),
                style: {
                    backgroundColor: category_1.ColorHex,
                },
            })), delay(() => append_1(singleton_1(reactElement("span", {
                className: join(" ", ["text-sm", "ml-1"]),
                children: category_1.Name,
            })), delay(() => (hasChildren ? singleton_1(reactElement("span", {
                className: join(" ", ["text-xs", "text-text-muted", "ml-1.5"]),
                children: `(${length(children_1)})`,
            })) : empty_1())))))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("td", createObj(ofArray([["className", join(" ", ["py-2.5", "px-4", "border-b", "border-border"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["inline-flex"])], (elems_3 = [createElement(Badge, {
            Color: category_1.ColorHex,
            Label: Hierarchy_getDisplayName(props.Categories, category_1),
            TestId: concat("badge-", ...LabelId__get_unwrap(category_1.Id)),
        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("td", createObj(ofArray([["className", join(" ", ["py-2.5", "px-4", "border-b", "border-border"])], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center"])], (elems_5 = [Checkbox({
            ComponentState: "enabled",
            IsChecked: category_1.VisibleForUserRole,
            Label: "",
            OnCheck: (_arg_1) => {
            },
            TestId: "",
        })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
    }, flatRows), ["children", reactApi.Children.toArray(Array.from(elems_11))]))))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))]))));
}

export function CategoriesOverview(props) {
    let elems_2, elems_1, elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", "tab-pane flex-grow-1 active"], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["d-flex", "flex-column"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-end", "mb-3", "controls"])], (elems = [createElement(Button, {
        ComponentState: "enabled",
        Label: patternInput[0]("settings.create_new_label"),
        OnClick: () => {
            RouterModule_nav(ofArray(["settings", "categories", "new"]), 1, 1);
        },
        TestId: "settings-create-new-label-button",
        Variant: "primary",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(CategoryTreeView, {
        Categories: props.Categories,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function CategoriesOverviewView() {
    let elems;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const patternInput_2 = reactApi.useState(false);
    const setCategoryLabelsOverviewTourDismissed = patternInput_2[1];
    const showCategoryLabelsOverviewTour = isCategoryLabelsTourOverviewPhase() && !patternInput_2[0];
    const matchValue = patternInput_1[0].Categories;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "table",
        });
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems = toList(delay(() => append_1(singleton_1(createElement(CategoriesOverview, {
            Categories: matchValue.fields[0],
            Dispatch: patternInput_1[1],
        })), delay(() => {
            let Steps;
            return showCategoryLabelsOverviewTour ? singleton_1(createElement(TourGuide, (Steps = singleton(new TourStep("[data-test-id=\'settings-create-new-label-button\']", t("onboarding.tour.category_new_button_title"), reactElement("div", {
                children: t("onboarding.tour.category_new_button_content"),
            }), "bottom", true)), {
                IsRunning: true,
                Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                OnFinish: () => {
                    setCategoryLabelsOverviewTourDismissed(true);
                    RouterModule_nav(ofArray(["settings", "categories", "new" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "category-labels-step"]))]), 1, 1);
                },
                OnSkip: () => {
                    setCategoryLabelsOverviewTourDismissed(true);
                    RouterModule_nav(ofArray(["settings", "categories" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())]), 1, 1);
                },
                ScrollFirstStep: true,
                Steps: Steps,
            }))) : empty_1();
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

